export default "__VITE_ASSET__DFlohHNA__";